import * as z from 'zod';
import { TFunction } from 'i18next';
import { phone } from 'phone';
import { requiredString } from '../../utils/validation';

const createRequiredPhoneSchema = (t: TFunction) =>
  requiredString(t).refine((value) => phone(value).isValid, { error: t('register.validation.invalidPhone') });

const createOptionalPhoneSchema = (t: TFunction) =>
  z
    .string()
    .optional()
    .refine((value) => !value || value === '' || phone(value).isValid, {
      error: t('register.validation.invalidPhone'),
    });

export function createPhoneSchema(t: TFunction, required: true): ReturnType<typeof createRequiredPhoneSchema>;
export function createPhoneSchema(t: TFunction, required?: false): ReturnType<typeof createOptionalPhoneSchema>;
export function createPhoneSchema(t: TFunction, required: boolean): z.ZodType<string | undefined, unknown>;
export function createPhoneSchema(t: TFunction, required = false): z.ZodType<string | undefined, unknown> {
  return required ? createRequiredPhoneSchema(t) : createOptionalPhoneSchema(t);
}

export const normalizePhoneNumber = (phoneNumber: string) => phoneNumber.replace(/\s+/g, '').replace(/^\+/, '');
